export default __webpack_public_path__ + "static/media/contactUs.30931a19.gif";